import axios from 'axios';

// API base URL - configured for Cloud Run via environment variable
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Shared axios instance — all domain gateways import from here
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Request interceptor: automatically add JWT token to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('transcend_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle auth errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // If 401 Unauthorized, clear token and redirect to login
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      // Don't redirect if already on login or auth pages
      if (!currentPath.includes('/login') && !currentPath.includes('/auth')) {
        // Remember where the user was so we can return them there after re-auth
        // (survives the OAuth round-trip; e.g. an idle session on /whereabouts).
        try {
          sessionStorage.setItem('returnTo', currentPath + window.location.search);
        } catch (e) { /* sessionStorage unavailable — fall through to home */ }
        localStorage.removeItem('transcend_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
